import { useMemo } from "react";
import { Combined, Article } from "../types/article";

export function useHfbDepartments(articles: Combined<Article>[]): string[] {
  const hfbDepartments = useMemo(() => {
    if (!articles || !articles.length) {
      return [];
    }
    const hfbMap = new Map<string, Combined<Article>[]>();
    for (const article of articles) {
      const hfb = article.hfb;
      if (!hfb) {
        continue;
      }
      if (hfbMap.has(hfb)) {
        hfbMap.get(hfb)!.push(article);
      } else {
        hfbMap.set(hfb, [article]);
      }
    }

    return [...hfbMap.keys()].sort();
  }, [articles]);

  return hfbDepartments;
}
